<template>
  <div id="app">
    <router-view :key="$route.path" />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        steps: [],
        trans_help: {
          LoadingDataPleaseWait: this.$t('common.LoadingDataPleaseWait')
        },
      }
    },
    methods: {

    },
    mounted() {
      this.$utils.startScripts();
      this.$utils.fadeOutLoading();
    },
    updated() {
      this.$utils.refreshScripts();
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue